(() => {
  'use strict';
  const dialog = document.querySelector('[data-fb-wishlist]');
  if (!dialog) return;
  const key = 'flora_boost_wishlist_v1';
  const list = dialog.querySelector('[data-fb-wishlist-list]');
  const status = document.getElementById('FbWishlistStatus');
  let items = [];
  let persistent = true;
  let returnFocus = null;
  function clean(item) {
    if (!item || typeof item.id !== 'string' || typeof item.title !== 'string' || typeof item.url !== 'string') return null;
    try {
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      let image = '';
      if (typeof item.image === 'string' && item.image) {
        const source = new URL(item.image, location.origin);
        if (source.protocol === 'https:' && (source.origin === location.origin || source.hostname === 'cdn.shopify.com')) image = source.href;
      }
      return { id: item.id.slice(0, 80), title: item.title.slice(0, 300), url: url.pathname + url.search, image };
    } catch { return null; }
  }
  function read() {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(stored)) items = [...new Map(stored.map(clean).filter(Boolean).map(item => [item.id, item])).values()].slice(0, 100);
    } catch { persistent = false; }
  }
  function save() {
    try { localStorage.setItem(key, JSON.stringify(items)); }
    catch { persistent = false; }
  }
  function feedback(message) {
    status.textContent = '';
    requestAnimationFrame(() => { status.textContent = message; });
  }
  function updateControls() {
    const ids = new Set(items.map(item => item.id));
    document.querySelectorAll('[data-fb-wishlist-toggle]').forEach(button => {
      const selected = ids.has(button.dataset.fbWishlistId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? button.dataset.fbWishlistRemoveLabel : button.dataset.fbWishlistAddLabel);
    });
    document.querySelectorAll('[data-fb-wishlist-open]').forEach(button => { button.hidden = false; });
    document.querySelectorAll('[data-fb-wishlist-count]').forEach(count => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
    dialog.querySelector('[data-fb-wishlist-total]').textContent = String(items.length);
    if (!persistent) dialog.querySelector('[data-fb-wishlist-privacy]').textContent = dialog.dataset.session;
  }
  function render() {
    list.replaceChildren();
    dialog.querySelector('[data-fb-wishlist-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('li');
      const pictureLink = document.createElement('a');
      pictureLink.href = item.url;
      pictureLink.tabIndex = -1;
      pictureLink.setAttribute('aria-hidden', 'true');
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 80;
        image.height = 90;
        image.loading = 'lazy';
        pictureLink.append(image);
      }
      const body = document.createElement('div');
      const heading = document.createElement('h3');
      const title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.title;
      heading.append(title);
      const actions = document.createElement('div');
      actions.className = 'fb-wishlist-actions';
      const view = document.createElement('a');
      view.href = item.url;
      view.textContent = dialog.dataset.view;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.fbWishlistRemove = item.id;
      remove.textContent = dialog.dataset.remove;
      remove.setAttribute('aria-label', dialog.dataset.remove + ': ' + item.title);
      actions.append(view, remove);
      body.append(heading, actions);
      row.append(pictureLink, body);
      list.append(row);
    });
    updateControls();
  }
  function open(trigger) {
    returnFocus = trigger;
    render();
    if (!dialog.open) dialog.showModal();
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-fb-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const item = clean({ id: toggle.dataset.fbWishlistId, title: toggle.dataset.fbWishlistTitle, url: toggle.dataset.fbWishlistUrl, image: toggle.dataset.fbWishlistImage });
      if (!item) return;
      const index = items.findIndex(saved => saved.id === item.id);
      if (index >= 0) { items.splice(index, 1); feedback(dialog.dataset.removed); }
      else if (items.length < 100) { items.push(item); feedback(dialog.dataset.added); }
      else { feedback(dialog.dataset.limit); return; }
      save();
      updateControls();
      if (dialog.open) render();
      return;
    }
    const opener = event.target.closest('[data-fb-wishlist-open], a[href$="#merkliste"]');
    if (opener) { event.preventDefault(); open(opener); return; }
    if (event.target.closest('[data-fb-wishlist-close]')) { dialog.close(); return; }
    const remove = event.target.closest('[data-fb-wishlist-remove]');
    if (remove) {
      items = items.filter(item => item.id !== remove.dataset.fbWishlistRemove);
      save(); render(); feedback(dialog.dataset.removed);
      dialog.querySelector('[data-fb-wishlist-close]').focus();
    }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
  window.addEventListener('storage', event => { if (event.key === key) { read(); updateControls(); if (dialog.open) render(); } });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-fb-wishlist-toggle]') || node.querySelector('[data-fb-wishlist-toggle]'))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; updateControls(); });
  }).observe(document.body, { childList: true, subtree: true });
  read(); updateControls();
  if (location.hash === '#merkliste') open(null);
})();
